import { Icon } from '@iconify/react';
import PriceChangeIcon from '@mui/icons-material/PriceChange';
// material
import { alpha, styled } from '@mui/material/styles';
import { Card, Typography } from '@mui/material';
// utils
import { useState, useEffect } from 'react';
import { fShortenNumber } from '../../../utils/formatNumber';

const axios = require('axios');

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.primary.darker,
  backgroundColor: theme.palette.primary.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0)} 0%, ${alpha(
    theme.palette.primary.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 714000;

export default function AppWeeklySales() {
  const [eth, setEth] = useState(0);
  useEffect(async () => {
    const res = await axios.get(
      'https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD,EUR,CNY,JPY,GBP'
    );
    const price = res.data.USD;
    setEth(price);
  });

  return (
    <RootStyle>
      <IconWrapperStyle>
        <PriceChangeIcon />
      </IconWrapperStyle>
      <Typography variant="h3">${eth}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Etherium Price
      </Typography>
    </RootStyle>
  );
}
